<div fxLayout="column">
    <div fxFlex="1 1 auto" fxLayout="row">
        <div fxFlex="1 1 20%" fxLayout="column">
            <div fxFlex="1 1 50%" [ngClass]="selectedBufferType == 'OPERATIONAL' ? 'selected-buffer liquitics-box' : 'liquitics-box'"
                fxLayout="column" (click)="setSelectedBufferType('OPERATIONAL')">
                <span class="cylinder-header liquitics-h5">Operational</span>
                <div fxFlex="1 1 auto"></div>
                <span class="cylinder-footer liquitics-h3">{{operationalSummary}}</span>
                <div fxFlex="1 1 auto"></div>
            </div>
            <div fxFlex="1 1 50%" [ngClass]="selectedBufferType == 'REGULATORY' ? 'selected-buffer liquitics-box' : 'liquitics-box'"
                fxLayout="column" (click)="setSelectedBufferType('REGULATORY')">
                <span class="cylinder-header liquitics-h5">Regulatory</span>
                <div fxFlex="1 1 auto"></div>
                <span class="cylinder-footer liquitics-h3">{{regulatorySummary}}</span>
                <div fxFlex="1 1 auto"></div>
            </div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <span class="liquitics-h5">Bond Type</span>
            <div id="typechartdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <span class="liquitics-h5">Sector</span>
            <div id="sectorchartdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <span class="liquitics-h5">Country</span>
            <div id="countrychartdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <span class="liquitics-h5">Rating</span>
            <div id="ratingchartdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <span class="liquitics-h5">Maturity</span>
            <div id="maturitychartdiv" class="chartdiv"></div>
        </div>
    </div>
    <div fxFlex="1 1 auto" fxLayout="row" fxLayoutGap="5px" class="liquitics-box">
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Collateral Type" [(ngModel)]="selectedSpecialCollateralTypes" multiple>
                <mat-option *ngFor="let option of specialCollateralTypes" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Bond Type" [(ngModel)]="selectedBondTypes" multiple>
                <mat-select-trigger>
                    {{selectedBondTypes ? ((selectedBondTypes.length > 0) ? selectedBondTypes[0].displayValue : '') : ''}}
                    <span *ngIf="selectedBondTypes?.length > 1" class="additional-selection">
                        (+{{selectedBondTypes.length - 1}} others)
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let option of bondTypes" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Country" [(ngModel)]="selectedCountries" multiple>
                <mat-select-trigger>
                    {{selectedCountries ? ((selectedCountries.length > 0) ? selectedCountries[0].displayValue : '') : ''}}
                    <span *ngIf="selectedCountries?.length > 1" class="additional-selection">
                        (+{{selectedCountries.length - 1}} others)
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let option of countries" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Sector" [(ngModel)]="selectedSectors" multiple>
                <mat-select-trigger>
                    {{selectedSectors ? ((selectedSectors.length > 0) ? selectedSectors[0].displayValue : '') : ''}}
                    <span *ngIf="selectedSectors?.length > 1" class="additional-selection">
                        (+{{selectedSectors.length - 1}} others)
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let option of sectors" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Rating" [(ngModel)]="selectedRatings" multiple>
                <mat-select-trigger>
                    {{selectedRatings ? ((selectedRatings.length > 0) ? selectedRatings[0].displayValue : '') : ''}}
                    <span *ngIf="selectedRatings?.length > 1" class="additional-selection">
                        (+{{selectedRatings.length - 1}} others)
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let option of ratings" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <mat-select placeholder="Stability" [(ngModel)]="selectedStabilityTypes" multiple>
                <mat-select-trigger>
                    {{selectedStabilityTypes ? ((selectedStabilityTypes.length > 0) ? selectedStabilityTypes[0].displayValue : '') : ''}}
                    <span *ngIf="selectedStabilityTypes?.length > 1" class="additional-selection">
                        (+{{selectedStabilityTypes.length - 1}} others)
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let option of stabilityTypes" [value]="option">
                    {{ option.displayValue }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <input matInput [matDatepicker]="nextCorporateActionStartDatePicker" [(ngModel)]="nextCorporateActionStartDate" name="nextCorporateActionStartDate"
                placeholder="CA Start">
            <mat-datepicker-toggle matSuffix [for]="nextCorporateActionStartDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #nextCorporateActionStartDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field fxFlex="0 1 auto">
            <input matInput [matDatepicker]="nextCorporateActionEndDatePicker" [(ngModel)]="nextCorporateActionEndDate" name="nextCorporateActionEndDate"
                placeholder="CA End">
            <mat-datepicker-toggle matSuffix [for]="nextCorporateActionEndDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #nextCorporateActionEndDatePicker></mat-datepicker>
        </mat-form-field>
        <!-- <mat-form-field fxFlex="1 1 auto">
        <mat-select placeholder="Columns" [(ngModel)]="selectedColumns" multiple>
            <mat-select-trigger>
                <mat-icon>configure</mat-icon>
            </mat-select-trigger>
            <mat-option *ngFor="let column of allColumns" [value]="column">
                {{ column.header }}
            </mat-option>
        </mat-select>
    </mat-form-field> -->
        <!-- <button mat-fab matTooltip="Search" matTooltipPosition="right" color="primary" (click)="search()">
            <mat-icon>search</mat-icon>
        </button> -->
        <button pButton type="button" (click)="search()" icon="fa fa-search" label="Search"></button>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="5px" class="liquitics-box">
        <!-- <mat-slide-toggle ngDefaultControl [(ngModel)]="showPositionsForWeek" color="primary" (change)="onShowPositionForWeekChange($event)">
            Show Week
        </mat-slide-toggle> -->
        <mat-button-toggle-group fxFlex="0 1 auto" name="securityDisplayToggle" [(ngModel)]="securityDisplayMode" aria-label="Security Display Mode"
            (change)="updateColumns()">
            <mat-button-toggle value="DEFAULT_SECURITY_ATTRIBUTES">Default Security Attribs</mat-button-toggle>
            <mat-button-toggle value="EXTENDED_SECURITY_ATTRIBUTES">Extended Security Attribs</mat-button-toggle>
            <mat-button-toggle value="SEVEN_DAY">7 Day</mat-button-toggle>
        </mat-button-toggle-group>
        <mat-slide-toggle fxFlex="0 1 auto" ngDefaultControl [(ngModel)]="showSelected" color="primary" class="show-selected-toggle">
            Show Selected
        </mat-slide-toggle>
        <!-- <mat-slide-toggle ngDefaultControl [(ngModel)]="showAllocations" color="primary" (change)="onShowAllocationsChange($event)">
            Show Allocations
        </mat-slide-toggle> -->
        <!-- <button mat-fab matTooltip="Search" matTooltipPosition="right" color="primary" (click)="saveBufferAllocations()">
            <mat-icon>save</mat-icon>
        </button> -->
        <!-- <div fxFlex="1 1 auto"></div> -->
        <button fxFlex="0 1 auto" pButton type="button" (click)="saveBufferAllocations()" icon="fa fa-save" label="Save"></button>
    </div>
    <p-table [columns]="selectedColumns" [frozenColumns]="frozenColumns" [frozenValue]="frozenSecurities" selectionMode="none"
        [(selection)]="frozenSecurities" frozenWidth="450px" [value]="tableData" scrollable="true" [scrollHeight]="vpHeightToPx(40)"
        class="security-table" [loading]="loading" dataKey="isin" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)">
        <!-- <ng-template pTemplate="header" let-columns>
        <th pReorderableColumn *ngFor="let col of columns">
            {{col.header}}
        </th>
    </ng-template> -->

        <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
                <!-- <col *ngFor="let col of columns" [style]="'width:'+col.width"> -->
                <col *ngFor="let col of columns" [style.width]="col.width">
            </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                    <mat-icon *ngIf="col.type === 'saved'">lock</mat-icon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="frozenrows" let-rowData let-columns="columns">
            <tr *ngIf="showSelected" [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" [ngClass]="'text-center'" [pEditableColumn]="col.editable">
                    <p-tableCheckbox *ngIf="col.type === 'check'" [value]="rowData"></p-tableCheckbox>
                    <span *ngIf="col.type === 'string'">
                        {{rowData[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'saved'">
                        <mat-icon *ngIf="rowData[col.field]">lock</mat-icon>
                    </span>
                    <span *ngIf="col.type === 'price'">
                        {{rowData[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'value'">
                        {{rowData[col.field] | currencyrounding:1:currency:false | negativeparentheses}}
                    </span>
                    <span *ngIf="col.type === 'position'">
                        {{rowData[col.field] | number:'1.0-2'}}
                    </span>
                    <p-cellEditor *ngIf="col.editable">
                        <ng-template pTemplate="input">
                            <p-spinner size="8" [(ngModel)]="rowData[col.field]" [min]="0" [max]="rowData.max" [step]="1000" (onChange)="onAllocationChange(rowData)"></p-spinner>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{rowData[col.field]}}
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr *ngIf="!(rowData.checked === true)" [pSelectableRow]="rowData">
                <td *ngFor="let col of columns" [ngClass]="'text-center'" [pEditableColumn]="col.editable">
                    <p-tableCheckbox *ngIf="col.type === 'check'" [value]="rowData"></p-tableCheckbox>
                    <span *ngIf="col.type === 'string'">
                        {{rowData[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'saved'">
                        <mat-icon *ngIf="rowData[col.field]">lock</mat-icon>
                    </span>
                    <span *ngIf="col.type === 'price'">
                        {{rowData[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'value'">
                        {{rowData[col.field] | currencyrounding:1:currency:false | negativeparentheses}}
                    </span>
                    <span *ngIf="col.type === 'position'">
                        {{rowData[col.field] | number:'1.0-2'}}
                    </span>
                    <p-cellEditor *ngIf="col.editable">
                        <ng-template pTemplate="input">
                            <p-spinner size="8" [(ngModel)]="rowData[col.field]" [min]="0" [max]="rowData.max" [step]="1000" (onChange)="onAllocationChange(rowData)"></p-spinner>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{rowData[col.field]}}
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>